module.exports = __webpack_public_path__ + "static/media/remove-format.30ec9304.svg";